import { QueryKey } from "react-query";

export const createUseClinicKey = (): QueryKey => ["useClinics"];
